export const structureFlaws = [
  {
    slug: 'EXECUTION_WIRING_ISSUE',
    meaning: 'The endpoint, method, parameter placement, identity binding, or request construction is incorrect.',
    detectionModes: ['code'],
    severity: 'high',
    fixCategories: ['executionContract', 'actionArguments'],
    repairPolicy: 'verified_review',
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      },
      configPaths: {
        type: 'stringArray',
        minItems: 1
      },
      contractViolation: {
        type: 'string'
      }
    },
    evidenceAlternatives: [],
    verificationRecipe: ['Verify URL interpolation, argument consumption, and identity resolution with a read-only run.', 'Leave hooks and credential-flow changes for human repair.'],
    legacyCodes: [],
    evidenceRelations: []
  },
  {
    slug: 'TRIGGER_ISSUE',
    meaning: 'Polling or webhook settings are missing or incorrect.',
    detectionModes: ['code'],
    severity: 'medium',
    fixCategories: ['executionContract'],
    repairPolicy: 'human_merge',
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      },
      configPaths: {
        type: 'stringArray',
        minItems: 1
      },
      contractViolation: {
        type: 'string'
      }
    },
    evidenceAlternatives: [],
    verificationRecipe: ['A human verifies the trigger configuration and its read action.', 'Do not execute or repair triggers automatically under the read-action contract.'],
    legacyCodes: [],
    evidenceRelations: []
  },
  {
    slug: 'CREDENTIAL_TEST_ISSUE',
    meaning: 'The connection test is missing or has an unusable action reference.',
    detectionModes: ['code'],
    severity: 'high',
    fixCategories: ['credentialTestAction'],
    repairPolicy: 'verified_review',
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      },
      authenticationRequired: {
        type: 'boolean',
        const: true
      },
      usableTestAction: {
        type: 'boolean',
        const: false
      },
      subKind: {
        type: 'string',
        enum: ['missing', 'broken_reference']
      }
    },
    evidenceAlternatives: [],
    verificationRecipe: ['test action runs successfully against the provider.'],
    legacyCodes: ['CREDENTIAL_TEST_ACTION_MISSING'],
    evidenceRelations: []
  },
  {
    slug: 'OTHER',
    meaning: 'An admin reports an action defect that does not fit a typed category. The fixer investigates it within the reported scope.',
    detectionModes: [],
    severity: 'medium',
    fixCategories: ['general'],
    repairPolicy: 'verified_review',
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [],
    verificationRecipe: ['Diagnose the reported defect within the action and API scope. Run the original action. Then run the final changed action and confirm success.'],
    legacyCodes: ['EXECUTION_HTTP_4XX_CONTRACT_SUSPECTED', 'ADMIN_REPORT'],
    evidenceRelations: []
  }
];
